export default __webpack_public_path__ + "static/media/filter-dark.d56bbe9c.svg";